var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":!_vm.activeStepIsComplete || _vm.changingStep},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.lastStepIsActive ? 'Finish' : 'Next'))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }